import { Item } from "../types/Item";

export const items: Item[] = [
   { date: new Date(2024, 5, 17), category: 'food', title: 'Burguer King', value: 35.99 },
   { date: new Date(2024, 5, 17), category: 'food', title: 'KFC', value: 49.99 },
   { date: new Date(2024, 5, 17), category: 'rent', title: 'Aluguel Casa', value: 2500 },
   { date: new Date(2024, 6, 19), category: 'salary', title: 'Salário', value: 5500 }
];